import { useLocation } from 'react-router-dom';
import Link from '@/components/redesign/JourneyLink';
import { getPublicNavigation } from '@/components/redesign/publicNavigation';

const RELATED = [
  [['/about', '/about-en'], ['benefits', 'agreements', 'contact']],
  [['/elpris-sammenligning', '/en/compare-electricity-companies'], ['agreements', 'benefits', 'savingMode']],
  [['/pris-time-for-time', '/en/electricity-price-hour-by-hour'], ['compare', 'agreements', 'savingMode']],
  [['/portal/smart-charge', '/en/smart-charge-price-guarantee'], ['benefits', 'cars', 'savingTerms']],
  [['/understoettede-bilmaerker', '/en/supported-car-brands'], ['benefits', 'chargers', 'agreements']],
  [['/supportkundeportal', '/en/support'], ['portal', 'contact', 'savingMode']],
  [['/kontakt'], ['support', 'agreements', 'benefits']],
  [['/blog', '/en/blog'], ['benefits', 'compare', 'chargers']],
  [['/henvisning'], ['portal', 'benefits', 'support']],
  [['/velkommen', '/en/welcome'], ['support', 'agreements', 'benefits']],
  [['/gebyrer'], ['delivery', 'agreements', 'contact']],
  [['/leveringsbetingelser'], ['fees', 'savingTerms', 'contact']],
  [['/privatlivspolitik'], ['cookies', 'contact']],
  [['/cookiepolitik'], ['privacy', 'contact']],
  [['/smart-charge-prisgaranti-vilkaar'], ['savingMode', 'benefits', 'cars']],
];

export default function PageContextLinks() {
  const { pathname } = useLocation();
  const path = pathname.toLowerCase().replace(/\/$/, '');
  const keys = RELATED.find(([paths]) => paths.includes(path))?.[1];
  if (!keys) return null;
  const en = path.startsWith('/en/') || path === '/about-en';
  const { links } = getPublicNavigation(en);
  return <nav className="ee-site ee-container border-t border-ee-line py-8 text-ee-ink" aria-label={en ? 'Related information' : 'Læs også'}>
    <p className="ee-eyebrow mb-4">{en ? 'Related information' : 'Læs også'}</p>
    <ul className="flex flex-wrap gap-x-7 gap-y-4">{keys.map(key => links[key]).filter(([, to]) => to !== path).map(([label, to]) => <li key={to}><Link className="ee-text-link text-sm" to={to}>{label}</Link></li>)}</ul>
  </nav>;
}